import { motion } from "framer-motion";
import { Clock, MapPin } from "lucide-react";
import { SCHEDULE, SCHEDULE_IMAGE, CHURCH } from "@/lib/data";

export default function Schedule() {
  return (
    <section
      id="cultos"
      data-testid="schedule-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${SCHEDULE_IMAGE})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-[#050505]/85" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-xs tracking-overline uppercase text-[#D4AF37] mb-6"
          >
            Horários dos Cultos
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.05 }}
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight"
            data-testid="schedule-title"
          >
            Encontre-nos <span className="italic text-white/80">durante</span> a semana.
          </motion.h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5">
          {SCHEDULE.map((item, idx) => (
            <motion.article
              key={item.day}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: idx * 0.1 }}
              data-testid={`schedule-card-${idx}`}
              className="group bg-[#0A0A0A] p-8 sm:p-10 hover:bg-[#0F0F0F] transition-colors duration-500"
            >
              <div className="flex items-baseline justify-between border-b border-white/10 pb-6">
                <p className="font-serif-display text-3xl sm:text-4xl text-white">
                  {item.day}
                </p>
                <span className="text-[10px] tracking-overline uppercase text-[#D4AF37]">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="mt-6 flex items-center gap-2 text-[#D4AF37]">
                <Clock size={16} strokeWidth={1.5} />
                <span className="text-sm tracking-wide">{item.time}</span>
              </div>
              <h3 className="mt-3 font-serif-display text-xl text-white">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-white/65">
                {item.description}
              </p>
            </motion.article>
          ))}
        </div>

        <div className="mt-12 inline-flex items-center gap-3 text-white/65 text-sm">
          <MapPin size={16} strokeWidth={1.5} className="text-[#D4AF37]" />
          <span>{CHURCH.address}</span>
        </div>
      </div>
    </section>
  );
}
